import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { body2, colors, duration, easing, extraLargeShadow } from 'ui/theme';
import { useDynamicHeatmapContext } from '../../context';

type DynamicTooltipProps = {
  x: number;
  y: number;
  text: string;
  urlKey: string;
};

const StyledOverlay = styled.polygon`
  -webkit-transition: fill-opacity ${duration.short} ${easing.standard},
    stroke-opacity ${duration.short} ${easing.standard};
  transition: fill-opacity ${duration.short} ${easing.standard},
    stroke-opacity ${duration.short} ${easing.standard};
  ${extraLargeShadow};
`;

const StyledText = styled.text`
  ${body2}
  font-feature-settings: "tnum";
  cursor: default;
  -webkit-transition: fill-opacity ${duration.short} ${easing.standard},
    stroke-opacity ${duration.short} ${easing.standard};
  transition: fill-opacity ${duration.short} ${easing.standard},
    stroke-opacity ${duration.short} ${easing.standard};
`;

export const DynamicTooltip = ({ x, y, text, urlKey }: DynamicTooltipProps) => {
  const { hoveredTooltipKey, setHoveredTooltipKey } = useDynamicHeatmapContext();
  const [opacity, setOpacity] = useState(0.75);

  useEffect(() => {
    if (hoveredTooltipKey && hoveredTooltipKey !== urlKey) {
      setOpacity(0.1);
    } else if (!hoveredTooltipKey) {
      setOpacity(0.6);
    }
  }, [hoveredTooltipKey]);

  return (
    <React.Fragment>
      <StyledOverlay
        onMouseEnter={() => {
          setOpacity(1);
          setHoveredTooltipKey(urlKey);
        }}
        onMouseLeave={() => {
          setOpacity(0.75);
          setHoveredTooltipKey('');
        }}
        fill={colors.green100}
        fillOpacity={opacity}
        strokeOpacity={hoveredTooltipKey ? opacity : 1}
        stroke={colors.grey80}
        strokeWidth={2}
        id={urlKey}
        points={[
          x - 64,
          y + 8,
          x - 64,
          y + 32,
          x + 64,
          y + 32,
          x + 64,
          y + 8,
          x + 8,
          y + 8,
          x,
          y,
          x - 8,
          y + 8,
        ].join(',')}
      />
      <StyledText
        x={x}
        y={y + 25}
        fill={colors.textOnColor}
        fillOpacity={hoveredTooltipKey ? opacity : 1}
        textAnchor="middle"
        onMouseEnter={() => {
          setOpacity(1);
          setHoveredTooltipKey(urlKey);
        }}
        onMouseLeave={() => {
          setOpacity(0.75);
          setHoveredTooltipKey('');
        }}
      >
        {text}
      </StyledText>
    </React.Fragment>
  );
};
